import { createQueryKeys } from '@lukemorales/query-key-factory';
import type { PreviewViewStandardLabel } from '@service-email/generated/schemas';

export const emailKeys = createQueryKeys('email', {
  all: null,
  labels: null,
  links: null,
  linksHealthProbe: null,
  backfillJobs: null,
  threads: null,
  thread: (threadId: string) => ({
    queryKey: [threadId],
  }),
  threadMessages: (threadId: string) => ({
    queryKey: ['messages', threadId],
  }),
  composeDraftState: (params: {
    draftId: string;
    threadId: string;
    inboxId?: string;
  }) => ({
    queryKey: ['compose-draft-state', params],
  }),
  scheduledMessages: (linkIds: string[]) => ({
    queryKey: [{ linkIds }],
  }),
  previews: (params: {
    view: PreviewViewStandardLabel;
    limit?: number;
    sort_method?: string;
  }) => ({
    queryKey: [{ infinite: true, ...params }],
  }),
});
